const liveStarRatingTestimonial = () => {
    if (document.body.classList.contains("post-type-arcadian_testimonial") && document.body.classList.contains("wp-admin")) {
        const ratingSlideInput = document.querySelector('#rating');
        
        // Create a sibling element once
        const newElement = document.createElement('div');
        newElement.id = 'rating-display';
        ratingSlideInput.parentNode.insertBefore(newElement, ratingSlideInput.nextSibling);

        ratingSlideInput.addEventListener('change', (e) => {

            newElement.textContent = `New rating: ${e.target.value}`;
        });
    }
};


if (document.readyState !== "loading") {
  liveStarRatingTestimonial();
} else {
  document.addEventListener("DOMContentLoaded", liveStarRatingTestimonial);
}
